import _ from 'lodash';

export class ServicingApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getPayments({ applicationId }) {
    return this.#http.get(`/api/applications/${applicationId}/servicing/payments`);
  }

  async createPayment({ applicationId, ...body }) {
    return this.#http.post(`/api/applications/${applicationId}/servicing/payments`, body);
  }

  async updatePayment({ applicationId, paymentId, ...body }) {
    return this.#http.put(
      `/api/applications/${applicationId}/servicing/payments/${paymentId}`,
      body,
    );
  }

  async deletePayment({ applicationId, paymentId }) {
    return this.#http.delete(`/api/applications/${applicationId}/servicing/payments/${paymentId}`);
  }

  async reversePayment({ applicationId, paymentId, ...body }) {
    return this.#http.post(
      `/api/applications/${applicationId}/servicing/payments/${paymentId}/reverse`,
      body,
    );
  }

  async getPaymentSchedule({ applicationId }) {
    return this.#http.get(`/api/applications/${applicationId}/servicing/payment-schedule`);
  }

  async getPaymentBreakdown({ applicationId, paymentDate, dueDate, amount, lateFee }) {
    const params = new URLSearchParams();

    if (paymentDate) {
      params.append('paymentDate', paymentDate);
    }

    if (dueDate) {
      params.append('dueDate', dueDate);
    }

    if (!_.isNil(amount)) {
      params.append('amount', amount);
    }

    if (!_.isNil(lateFee)) {
      params.append('lateFee', lateFee);
    }

    const query = params.toString();

    return this.#http.get(
      `/api/applications/${applicationId}/servicing/payment-breakdown${query ? `?${query}` : ''}`,
    );
  }

  async getEscrowDisbursements({ applicationId }) {
    return this.#http.get(`/api/applications/${applicationId}/servicing/escrow-disbursements`);
  }

  async createEscrowDisbursement({ applicationId, ...body }) {
    return this.#http.post(
      `/api/applications/${applicationId}/servicing/escrow-disbursements`,
      body,
    );
  }

  async updateEscrowDisbursement({ applicationId, disbursementId, ...body }) {
    return this.#http.put(
      `/api/applications/${applicationId}/servicing/escrow-disbursements/${disbursementId}`,
      body,
    );
  }

  async deleteEscrowDisbursement({ applicationId, disbursementId }) {
    return this.#http.delete(
      `/api/applications/${applicationId}/servicing/escrow-disbursements/${disbursementId}`,
    );
  }

  async getSummary({ applicationId }) {
    return this.#http.get(`/api/applications/${applicationId}/servicing/summary`);
  }

  async getInteractions({ applicationId }) {
    return this.#http.get(`/api/applications/${applicationId}/servicing/interactions`);
  }

  async createInteraction({ applicationId, ...body }) {
    return this.#http.post(`/api/applications/${applicationId}/servicing/interactions`, body);
  }

  async updateInteraction({ applicationId, interactionId, ...body }) {
    return this.#http.put(
      `/api/applications/${applicationId}/servicing/interactions/${interactionId}`,
      body,
    );
  }

  async deleteInteraction({ applicationId, interactionId }) {
    return this.#http.delete(
      `/api/applications/${applicationId}/servicing/interactions/${interactionId}`,
    );
  }

  async getDrawRequests({ applicationId }) {
    return this.#http.get(`/api/applications/${applicationId}/servicing/draw-requests`);
  }

  async createDrawRequest({ applicationId, ...body }) {
    return this.#http.post(`/api/applications/${applicationId}/servicing/draw-requests`, body);
  }

  async updateDrawRequest({ applicationId, drawRequestId, ...body }) {
    return this.#http.put(
      `/api/applications/${applicationId}/servicing/draw-requests/${drawRequestId}`,
      body,
    );
  }
}
